import React, { useState } from 'react';
import { Steps } from 'antd';
import './Dashboard.scss';
import { steps } from '../../utils/dashboard';
import Main from '../../components/BlockElement/Main/Main';
import { useSite } from '../../hooks/useSite';
import { useSteps } from '../../hooks/useSteps';
import Site from '../../components/Site/Site';
import Text from '../../components/Text/Text';
import Operation from '../../components/Operation/Operation';

export default function Dashboard() {
    const { site, setSite, sites, addSite, deleteSite, updateSite } = useSite();
    const { current, next, prev } = useSteps(0);
    const [ops, setOps] = useState('');

    return (
        <Main className='dashboard'>
            <div className='dashboard__header'>
                <span className='dashboard__cross'>✝</span>
                <h1 className='dashboard__title'>Panel administracyjny</h1>
            </div>

            <div className='dashboard__card'>
                <Steps current={current} items={steps} className='dashboard__steps' />
                <div className='dashboard__content'>
                    {current === 0 && (
                        <Site site={site} setSite={setSite} sites={sites} addSite={addSite} deleteSite={deleteSite} next={next} />
                    )}
                    {current === 1 && (
                        <Operation val={ops} setVal={setOps} next={next} prev={prev} />
                    )}
                    {current === 2 && (
                        <Text site={site} ops={ops} sites={sites} updateSite={updateSite} prev={prev} />
                    )}
                </div>
            </div>
        </Main>
    );
}
